import component from './component'

export default {
    path: '/dashboard',
    name: 'dashboard',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/dashboard/index/index.js